export default {
  scheduleTime: {},
  scheduleTimes: [] // RECEBE TODOS OS HORÁRIOS. UTILIZADO NO CADASTRO DE NOVOS HORÁRIOS SEMANAIS
}
